import { render, staticRenderFns } from "./roleCell.vue?vue&type=template&id=5fb295bc&scoped=true&"
import script from "./roleCell.vue?vue&type=script&lang=js&"
export * from "./roleCell.vue?vue&type=script&lang=js&"
import style0 from "./roleCell.vue?vue&type=style&index=0&id=5fb295bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb295bc",
  null
  
)

export default component.exports